// import React, { useEffect, useState } from "react";

// const logo = "/assets/img/logo/logo.png";

// function Header() {
//   const [sticky, setSticky] = useState(false);
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [activeSection, setActiveSection] = useState("home");

//   useEffect(() => {
//     const sections = ["home", "journey", "about", "features", "courses", "programs", "results", "contact"];

//     const handleScroll = () => {
//       setSticky(window.scrollY > 50);

//       const scrollY = window.scrollY + 10;

//       for (let section of sections) {
//         const el = document.getElementById(section);
//         if (el) {
//           if (
//             scrollY >= el.offsetTop &&
//             scrollY < el.offsetTop + el.offsetHeight
//           ) {
//             setActiveSection(section);
//           }
//         }
//       }
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   const handleNavClick = () => {
//     setMenuOpen(false);
//   };

//   return (
//     <header className={`header header-6 ${sticky ? "sticky" : ""}`}>
//       <div className="navbar-area">
//         <div className="container">
//           <div className="row align-items-center">
//             <div className="col-lg-12">
//               <nav className="navbar navbar-expand-lg">
//                 {/* Logo */}
//                 <a className="navbar-brand" href="#home">
//                   <img src={logo} alt="Logo" />
//                 </a>

//                 {/* Toggle */}
//                 <button
//                   className={`navbar-toggler ${menuOpen ? "active" : ""}`}
//                   type="button"
//                   onClick={() => setMenuOpen(!menuOpen)}
//                 >
//                   <span className="toggler-icon"></span>
//                   <span className="toggler-icon"></span>
//                   <span className="toggler-icon"></span>
//                 </button>

//                 {/* Menu */}
//                 <div
//                   className={`collapse navbar-collapse sub-menu-bar ${
//                     menuOpen ? "show" : ""
//                   }`}
//                   id="navbarSupportedContent6"
//                 >
//                   <ul id="nav6" className="navbar-nav ms-auto">
//                     <li className="nav-item">
//                       <a
//                         href="#home"
//                         className={`page-scroll ${
//                           activeSection === "home" ? "active" : ""
//                         }`}
//                         onClick={handleNavClick}
//                       >
//                         Home
//                       </a>
//                     </li>

//                     <li className="nav-item">
//                       <a
//                         href="#journey"
//                         className={`page-scroll ${
//                           activeSection === "journey" ? "active" : ""
//                         }`}
//                         onClick={handleNavClick}
//                       >
//                         Journey
//                       </a>
//                     </li>

//                     <li className="nav-item">
//                       <a
//                         href="#about"
//                         className={`page-scroll ${
//                           activeSection === "about" ? "active" : ""
//                         }`}
//                         onClick={handleNavClick}
//                       >
//                         About
//                       </a>
//                     </li>

//                     <li className="nav-item">
//                       <a
//                         href="#features"
//                         className={`page-scroll ${
//                           activeSection === "features" ? "active" : ""
//                         }`}
//                         onClick={handleNavClick}
//                       >
//                         Features
//                       </a>
//                     </li>

//                     <li className="nav-item">
//                       <a
//                         href="#courses"
//                         className={`page-scroll ${
//                           activeSection === "courses" ? "active" : ""
//                         }`}
//                         onClick={handleNavClick}
//                       >
//                         Courses
//                       </a>
//                     </li>

//                     <li className="nav-item">
//                       <a
//                         href="#programs"
//                         className={`page-scroll ${
//                           activeSection === "programs" ? "active" : ""
//                         }`}
//                         onClick={handleNavClick}
//                       >
//                         Programs
//                       </a>
//                     </li>

//                     <li className="nav-item">
//                       <a
//                         href="#results"
//                         className={`page-scroll ${
//                           activeSection === "results" ? "active" : ""
//                         }`}
//                         onClick={handleNavClick}
//                       >
//                         Results
//                       </a>
//                     </li>

//                     <li className="nav-item">
//                       <a
//                         href="#contact"
//                         className={`page-scroll ${
//                           activeSection === "contact" ? "active" : ""
//                         }`}
//                         onClick={handleNavClick}
//                       >
//                         Contact
//                       </a>
//                     </li>
//                   </ul>
//                 </div>

//                 {/* LOGIN BUTTON */}
//                 <div className="header-action d-flex align-items-center">
//                   <a
//                     href="#0"
//                     className="button radius-30 text-white ml-30 px-4 py-2"
//                   >
//                     Login
//                   </a>
//                 </div>
//               </nav>
//             </div>
//           </div>
//         </div>
//       </div>
//     </header>
//   );
// }

// export default Header;

import React, { useEffect, useState } from "react";
const logo = "/assets/img/logo/Logo.png";

import { useNavigate } from "react-router";
import { useMediaQuery } from "Components/Custom_hooks/Custom";

function Header() {
  const navigate = useNavigate();
  const [sticky, setSticky] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("home");
  const isMobile = useMediaQuery("(max-width:700px)");
  
  useEffect(() => {
    const sections = [
      "home",
      "journey",
      "about",
      "features",
      "courses",
      "programs",
      "results",
      "contact",
    ];

    const handleScroll = () => {
      setSticky(window.scrollY > 40);

      const scrollY = window.scrollY + 120;

      sections.forEach((section) => {
        const el = document.getElementById(section);

        if (el) {
          if (
            scrollY >= el.offsetTop &&
            scrollY < el.offsetTop + el.offsetHeight
          ) {
            setActiveSection(section);
          }
        }
      });
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = () => {
    setMenuOpen(false);
  };

  const navItems = [
    "home",
    "journey",
    "about",
    "features",
    "courses",
    "programs",
    "results",
    "contact",
  ];

  return (
    <>
      <header
        className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
          sticky ? "bg-white shadow-lg py-2" : "bg-transparent py-4"
        }`}
      >
        <div
          style={{
            width: "100%",
            paddingLeft: "30px",
            paddingRight: "30px",
          }}
        >
          <nav
            className="navbar navbar-expand-lg"
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
            }}
          >
            {/* LOGO */}
            <a
              className="navbar-brand"
              href="#home"
              style={{
                display: "flex",
                alignItems: "center",
                margin: 0,
                padding: 0,
              }}
            >
              <img
                src={logo}
                alt="Logo"
                style={{
                  height: !isMobile ? "85px" : "50px",
                  width: "auto",
                  objectFit: "contain",
                }}
              />
            </a>

            {/* MOBILE BUTTON */}
            <button
              className="navbar-toggler"
              type="button"
              onClick={() => setMenuOpen(!menuOpen)}
              style={{
                border: "none",
                background: "#3b52ff",
                padding: "10px 12px",
                borderRadius: "10px",
                display: "none",
                flexDirection: "column",
                gap: "4px",
              }}
            >
              <span className="toggler-icon"></span>
              <span className="toggler-icon"></span>
              <span className="toggler-icon"></span>
            </button>

            {/* MENU */}
            <div
              className={`navbar-collapse ${menuOpen ? "showMenu" : ""}`}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: "25px",
                flex: 1,
                marginLeft: "auto",
              }}
            >
              <ul
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  listStyle: "none",
                  margin: 0,
                  padding: 0,
                }}
              >
                {navItems.map((item) => (
                  <li key={item}>
                    <a
                      href={`#${item}`}
                      onClick={handleNavClick}
                      style={{
                        textDecoration: "none",
                        fontWeight: "600",
                        fontSize: "15px",
                        padding: "10px 14px",
                        borderRadius: "10px",
                        transition: "0.3s",
                        textTransform: "capitalize",
                        color:
                          activeSection === item
                            ? "#3b52ff"
                            : sticky
                              ? "#111827"
                              : "#ffffff",
                        background:
                          activeSection === item
                            ? "rgba(79,70,229,0.1)"
                            : "transparent",
                      }}
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>

              {/* LOGIN BUTTON */}
              <div
                style={{ cursor: "pointer" }}
                onClick={() => {
                  navigate("/auth");
                }}
              >
                <a
                  style={{
                    background: "#3b52ff",
                    color: "white",
                    padding: "12px 24px",
                    borderRadius: "12px",
                    textDecoration: "none",
                    fontWeight: "600",
                    boxShadow: "0 8px 24px rgba(79,70,229,0.25)",
                    whiteSpace: "nowrap",
                  }}
                >
                  Login
                </a>
              </div>
            </div>
          </nav>
        </div>
        <style>{`
    .toggler-icon{
      width:22px;
      height:2px;
      background:white;
      display:block;
    }

    @media(max-width:991px){

      .navbar-toggler{
        display:flex !important;
      }

      .navbar-collapse{
        position:fixed;
        top:0;
        left:-100%;
        width:280px;
        height:100vh;
        background:white;
        flex-direction:column;
        align-items:flex-start !important;
        justify-content:flex-start;
        padding:100px 25px 25px;
        transition:0.3s;
        z-index:999;
        box-shadow:0 0 30px rgba(0,0,0,0.1);
      }

      .showMenu{
        left:0;
      }

      .navbar-collapse ul{
        flex-direction:column;
        align-items:flex-start !important;
        width:100%;
      }

      .navbar-collapse ul li{
        width:100%;
      }

      .navbar-collapse ul li a{
        display:block;
        width:100%;
        color:#111827 !important;
      }
    }
  `}</style>
      </header>
    </>
  );
}

export default Header;
